import { useEffect, useState } from "react";
import { GetAccessToken } from "../../../../../utils/auth-utils";
import { scopes } from "../../../../../authConfig";
import { salesAppointmentsService } from "../../../../../services/sales-appointments-service";
import { useMsal } from "@azure/msal-react";
import { Select } from "antd";
import { CustomerRuleOutcome } from "../../../../../dto/admin-rule-models";

type SetSetOpportunityScriptType = {
  outcome: CustomerRuleOutcome
  onChange: (outcome: string) => void;
}

export const SetOpportunityScript = ({ outcome, onChange }: SetSetOpportunityScriptType) => {

  const [scriptNames, setScriptNames] = useState<string[]>([]);
  const [loadingScripts, setLoadingScripts] = useState(false);
  const { instance, inProgress, accounts } = useMsal();


  useEffect(() => {
    (async () => {
      setLoadingScripts(true);
      const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
      const scriptsData = await salesAppointmentsService.getScripts(await token.accessToken!);
      if (!scriptsData.isSuccess) {
        // TODO: Add some indication that no scripts data was loaded?
        setScriptNames([]);
        setLoadingScripts(false);
        return;
      }
      setScriptNames(scriptsData.data.map(x => x.name));
      setLoadingScripts(false);
    })();
  }, []);

  return (
    <Select
      placeholder="Value"
      value={outcome.actionValue || undefined}
      loading={loadingScripts}
      onChange={onChange}
      style={{ width: "100%" }}
      showSearch
      allowClear
    >
      {scriptNames.map(name => (
        <Select.Option key={name} value={name}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
}